// extracted by mini-css-extract-plugin
module.exports = {"productsBreakdownSection":"styles_productsBreakdownSection__fzFol","mixAndMatchSection":"styles_mixAndMatchSection__JSV_x","callOutSection":"styles_callOutSection__lg7gW"};